var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.12,
    height: 68.004,
    viewBox: "0 0 89.12 68.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-message",
    transform: "translate(-3.44 -13.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M92.56,35.734V72a10.011,10.011,0,0,1-10,10H13.44a10.011,10.011,0,0,1-10-10V21a7.009,7.009,0,0,1,2.306-5.192,4,4,0,0,1,5.481.109L38.2,42.338a14.076,14.076,0,0,0,19.591,0L78.564,22H25.406c0-.006-7.994-8-7.994-8h8.076S85.56,14,85.56,14a6.99,6.99,0,0,1,4.7,1.812,4,4,0,0,1,.112,5.822L63.394,48.055a22.121,22.121,0,0,1-30.787,0L11.44,27.323V72a2,2,0,0,0,2,2H82.56a2,2,0,0,0,2-2V35.735s8-8,8-8S92.556,35.734,92.56,35.734Z",
    fill: "#0071b9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.9bce4ffb98f606075a79a57061aaf964.svg";
export { ForwardRef as ReactComponent };